import { IBenefitCountryOptions, ICartSettings, IDeliverySettings, IPaymentSettings } from '@model';

export enum ECartPageFeatures {
  GIFT_PACKAGING_MODAL_ON = 'GiftPackaging_On',
  GIFT_PACKAGING_MAX_BOXES = 'GiftPackaging_MaxBoxes',
  GIFT_PACKAGING_MAX_PRODUCTS = 'GiftPackaging_MaxProducts',
  GIFT_PACKAGING_URL = 'GiftPackaging_Url',
  GIFT_PACKAGING_GIFT_CARD_ON = 'GiftPackaging_GiftCard_On',
  GIFT_PACKAGING_GIFT_CARD_TEXT_LIMIT = 'GiftPackaging_GiftCard_TextLimit',
  ECO_PACKAGING_ON = 'showEcoPackaging',
  REPEAT_LAST_ORDER = 'RepeatLastOrder',
  LOYALTY_MODAL_IMAGE_URL = 'Loyalty_FreeDeliveryModal_Image',
  SHOW_GIFT_SELECTION_BY_DEFAULT = 'ShowGiftSelectionByDefault',
  INSURANCE_ENABLED = 'Insurance_On',
  INSURANCE_URL = 'Insurance_Url',
  VOUCHER_UNDER_PRODUCT_ENABLED = 'VoucherUnderProduct_On',
}

export interface ICartPageSettings extends ICartSettings, IDeliverySettings, IPaymentSettings, IBenefitCountryOptions {}
